import { useQuery } from '@apollo/client'
import { BucketShareAlbumDocument } from '../../../graphql/generated'

export default function useBucketShareAlbum(shareId?: string, albumId?: string) {
  const result = useQuery(BucketShareAlbumDocument, {
    variables: { shareId: shareId!, albumId: albumId! },
    skip: !shareId || !albumId
  })
  const album = result.data?.bucketShareAlbum

  return { album }
}
